module.exports = __webpack_public_path__ + "static/thumbnail-f5657eb02c34ba7bee68282c393dbc26.png";